// exactly the same as the base, so this is just for future updates.
import baseComponent from './VisitOrOnlineListForClient.vue'

export default baseComponent;
